import React from 'react';
import {Card, Col, Row, Typography} from 'antd';
import PropTypes from 'prop-types';
import {useGetCompanyInfoQuery} from "../../store/api/settingsApi";

const MassEmailPreview = ({subject, body, massEmailCount}) => {
    const {data: companyInfo} = useGetCompanyInfoQuery();
    const companyName = companyInfo.name;

    return (
        <Card>
            <Row>
                <Col xs={12} md={12}>
                    <Typography.Text strong>Number of recipients:</Typography.Text>
                </Col>
                <Col xs={12} md={12}>
                    <span className="long-text-wrap">{massEmailCount}</span>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <Typography.Text strong>Subject:</Typography.Text>
                </Col>
                <Col xs={12} md={12}>
                    <span className="long-text-wrap">{subject}</span>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <Typography.Text strong>Body: </Typography.Text>
                </Col>
                <Col xs={12} md={12}>
                    <p>Hello,</p>
                    <div className="long-text-wrap" dangerouslySetInnerHTML={{__html: body}}/>
                    <p>Regards,<br/>{companyName}</p>
                </Col>
            </Row>
        </Card>
    );
}

MassEmailPreview.propTypes = {
    subject: PropTypes.string,
    body: PropTypes.string,
    massEmailCount: PropTypes.number.isRequired
}

export default MassEmailPreview;
